import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { ASSIGN_VENDOR_REMARKS_LIST, ASSIGN_VENDOR_REMARKS_LIST_ERROR, ASSIGN_VENDOR_REMARKS_LIST_SUCCESS } from '../../../actions.js';

function* assignVendorRemarksList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/remarks`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: ASSIGN_VENDOR_REMARKS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: ASSIGN_VENDOR_REMARKS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ASSIGN_VENDOR_REMARKS_LIST_ERROR, payload: error });
  }
}

export function* watchAssignVendorRemarksList() {
  yield takeEvery(ASSIGN_VENDOR_REMARKS_LIST, assignVendorRemarksList);
}

function* assignVendorRemarksListSaga() {
  yield all([fork(watchAssignVendorRemarksList)]);
}

export default assignVendorRemarksListSaga;
